import { base64ToBlob } from '@theprintbar/shared';
import axios from 'axios';
import { WebRoutes, withDomain } from '../../../routes';
import { EmbroideryData, EmbroideryTrueview } from '../../../typings';
import { getBase64, logError } from '../../../utils';
import { Decoration } from '../../decoration';

export async function getDecorationTrueview({ decoration, webDomain }: { decoration: Decoration; webDomain?: string }) {
	if (!decoration.artwork) throw 'No artwork provided';

	const data: EmbroideryData = {
		//Convert the image to base64
		image: await getBase64(decoration.artwork),
		width: decoration.meta.width,
		height: decoration.meta.height,
	};

	const res = await axios.post<EmbroideryTrueview>(withDomain(WebRoutes.API.commerce.design.embroideryTrueview, webDomain), data, {
		validateStatus: () => true,
	});

	if (res.status !== 200) {
		throw res.data;
	}

	return {
		stitches: parseInt(res.data.stitches),
		//Convert the base64 image to a blob
		trueview: await base64ToBlob(res.data.image, 'image/png'),
	};
}
